import ModalProvider from "common/providers/modal/modalProvider";
import { Vehicle } from "schema-dts";
import { VehicleService } from "services/vehicle/vehicle";

import ClosestStoresProvider, {
    ClosestStoresProviderProps,
} from "./closestStores/closestStoresProvider";
import FinanceDataProvider from "./financeData/financeDataProvider";
import PartExchangeQuestionsProvider, {
    PartExchangeQuestionsProviderProps,
} from "./partExchangeQuestions/partExchangeQuestionsProvider";

type PDPProvidersProps = ClosestStoresProviderProps &
    PartExchangeQuestionsProviderProps & { vehicle: VehicleService.Vehicle };

const PDPProviders = ({ children, ...props }: PDPProvidersProps) => {
    return (
        <FinanceDataProvider>
            <PartExchangeQuestionsProvider>
                <ClosestStoresProvider {...props}>
                    <ModalProvider>{children}</ModalProvider>
                </ClosestStoresProvider>
            </PartExchangeQuestionsProvider>
        </FinanceDataProvider>
    );
};

export default PDPProviders;
